import { render, staticRenderFns } from "./CustomerContacts.vue?vue&type=template&id=41ea8bb1&scoped=true&"
import script from "./CustomerContacts.vue?vue&type=script&lang=ts&"
export * from "./CustomerContacts.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerContacts.vue?vue&type=style&index=0&id=41ea8bb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ea8bb1",
  null
  
)

export default component.exports